import { useMemo } from 'react';
import { useAuthStore } from '@/stores/auth';
import { TenantListItem, useTenantStore } from '@/stores/tenant';

const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

export function getTenantBrandColor(tenant: TenantListItem | null): string | null {
  if (!tenant?.settings) return null;
  const color = tenant.settings.brandColor;
  return typeof color === 'string' && HEX_COLOR_REGEX.test(color) ? color : null;
}

export function useTenant() {
  const { user } = useAuthStore();
  const {
    mode,
    activeTenantId,
    tenantList,
    setMode,
    setActiveTenantId,
    setTenantList,
    hydrateTenantContext,
    clearInvalidSelection,
    resetTenantContext,
  } = useTenantStore();

  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';
  const isStaff = user?.role === 'manager' || user?.role === 'user';
  const isTenantContextReady = isStaff || isAdmin;

  const activeTenant = useMemo(
    () => tenantList.find(tenant => tenant.id === activeTenantId) ?? null,
    [tenantList, activeTenantId]
  );

  const brandColor = useMemo(() => getTenantBrandColor(activeTenant), [activeTenant]);

  return {
    mode,
    activeTenantId,
    activeTenant,
    brandColor,
    tenantList,
    isAdmin,
    isStaff,
    isTenantContextReady,

    setMode,
    setActiveTenantId,
    setTenantList,
    hydrateTenantContext,
    clearInvalidSelection,
    resetTenantContext,
  };
}
